import api, { createCancelTokenHandler } from "../utils/services/api.service";
import { ENV } from "../constants";

const ShortLinkRepository = {
  all(params?: any) {
    return api.get(`${ENV.getApiEndPoint()}/api/short-link`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.all.name].handleRequestCancellation()
          .token,
    });
  },
  show(id: string, params?: any) {
    return api.get(`${ENV.getApiEndPoint()}/api/short-link/${id}`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.show.name].handleRequestCancellation()
          .token,
    });
  },
  create: function (payload: any, params: any = null) {
    return api.post(`${ENV.getApiEndPoint()}/api/short-link`, payload, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.create.name].handleRequestCancellation()
          .token,
    });
  },
  update: function (id: string | number, payload: any, params: any = null) {
    return api.put(`${ENV.getApiEndPoint()}/api/short-link/${id}`, payload, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.update.name].handleRequestCancellation()
          .token,
    });
  },
  delete: function (id: string | number, params: any = null) {
    return api.delete(`${ENV.getApiEndPoint()}/api/short-link/${id}`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.delete.name].handleRequestCancellation()
          .token,
    });
  },
};

const cancelTokenHandlerObject = createCancelTokenHandler(
  ShortLinkRepository
);

export default ShortLinkRepository;
